import teleport_data from "./teleport_data";
import { Transportation } from "../lib/runescape/transportation";
import { lazy } from "../lib/Lazy";
export var TransportData;
(function (TransportData) {
    var TeleportGroup = Transportation.TeleportGroup;
    const cached_data = {};
    TransportData.teleports = teleport_data;
    async function getCacheTransports() {
        if (!cached_data.cache_extracted) {
            cached_data.cache_extracted = await (await fetch(`map/cache_transportation.json`, { cache: "no-store" })).json();
        }
        return cached_data.cache_extracted;
    }
    TransportData.getCacheTransports = getCacheTransports;
    async function getAll() {
        if (!cached_data.all_transports) {
            cached_data.all_transports = [].concat(await getCacheTransports(), TransportData.teleports);
        }
        return cached_data.all_transports;
    }
    TransportData.getAll = getAll;
    function getTeleportGroup(id) {
        return TransportData.teleports.find(g => g.id == id);
    }
    TransportData.getTeleportGroup = getTeleportGroup;
    const _teleport_spots = lazy(() => {
        return TransportData.teleports.filter(TeleportGroup.canBeAccessedAnywhere).flatMap(group => {
            return group.spots.map(spot => {
                return new Transportation.TeleportGroup.Spot(group, spot, undefined);
            });
        });
    });
    function getAllTeleportSpots() {
        return _teleport_spots.get();
    }
    TransportData.getAllTeleportSpots = getAllTeleportSpots;
    function resolveTeleport(id) {
        const group = TransportData.teleports.find(g => g.id == id.group);
        const spot = group?.spots?.find(s => s.id == id.spot);
        const access = id.access ? group?.access?.find(a => a.id == id.access) : undefined;
        if (!group || !spot || (id.access && !access)) {
            debugger;
            return undefined;
        }
        return new Transportation.TeleportGroup.Spot(group, spot, access);
    }
    TransportData.resolveTeleport = resolveTeleport;
})(TransportData || (TransportData = {}));
